<div *ngIf="formGroup">
  <form *transloco="let t; read: 'custom-attribute-input'"
    [formGroup]="formGroup"
    (ngSubmit)="handleFormSubmit()">
    <ng-container [ngSwitch]="customAttribute.type">
      <div *ngSwitchCase="customAttributeType.TEXT">
        <accredible-text-input [formControlRef]="getFormControl(formGroup, 'field')"
          [placeholder]="autoSubmit ? '' : customAttribute.description"
          [label]="autoSubmit ? customAttribute.label : customAttribute.description || customAttribute.label">
        <span *ngIf="getFormControl(formGroup, 'field').hasError('required')"
          [innerHTML]="t('field.errors.required')">
        </span>
        </accredible-text-input>
      </div>

      <fieldset *ngSwitchCase="customAttributeType.SELECT_ANY"
        role="group"
        [attr.aria-label]="autoSubmit ? customAttribute.label : customAttribute.description || customAttribute.label"
        class="form-row">
        <legend>{{ autoSubmit ? customAttribute.label : customAttribute.description || customAttribute.label }}</legend>

        <accredible-checkbox-input *ngFor="let option of customAttribute.options; let i = index"
          [color]="'accent'"
          [size]="autoSubmit? 'large' : 'normal'"
          [class.slight-margin-bottom]="autoSubmit"
          [formControlRef]="getFormArrayControl(getFormArray(formGroup, 'field').controls[i])">
          <span [innerHTML]="option.label"></span>
        </accredible-checkbox-input>
      </fieldset>

      <fieldset *ngSwitchCase="customAttributeType.BOOLEAN"
        role="group"
        [attr.aria-label]="customAttribute.label"
        class="form-row">
        <legend *ngIf="autoSubmit">
          {{ customAttribute.label }}
        </legend>

        <accredible-checkbox-input [color]="'accent'"
          [size]="autoSubmit? 'large' : 'normal'"
          [formControlRef]="getFormControl(formGroup, 'field')">
          <span [innerHTML]="customAttribute.description"></span>
        </accredible-checkbox-input>
      </fieldset>

      <fieldset *ngSwitchCase="customAttributeType.SELECT_ONE"
        role="group"
        [attr.aria-label]="autoSubmit ? customAttribute.label : customAttribute.description || customAttribute.label"
        class="form-row">
        <legend>
          <span>{{ autoSubmit ? customAttribute.label : customAttribute.description || customAttribute.label }}</span>
          <button *ngIf="autoSubmit && getFormControl(formGroup, 'field').value"
            mat-stroked-button
            class="mat-default mat-button-small"
            (click)="resetSelectOne()">{{ t('clear') }}
          </button>
        </legend>

        <accredible-radio-input direction="vertical"
          [color]="'accent'"
          [size]="autoSubmit? 'large' : 'normal'"
          [class.slight-margin-bottom]="autoSubmit"
          [formControlRef]="getFormControl(formGroup, 'field')"
          [options]="radioInputOptions">
        </accredible-radio-input>
      </fieldset>
    </ng-container>

    <accredible-button-loading *ngIf="!autoSubmit"
      btnType="submit"
      [disableBtn]="!canSave"
      [isLoading]="isSaving"
      [btnText]="t('save')">
    </accredible-button-loading>
  </form>
</div>
